(function() {
  'use strict';

  // i18n() is a no-op marker so the extraction script can find these keys.
  function i18n(key) { return key; }

  var requestResetPasswordURL = 'accounts/pw_reset_request';

  var states = {
    active: {
      id: 'active',
      name: i18n('Active'),
      labelStyle: 'success',
      borderStyle: 'complete'
    },
    disabled: {
      id: 'disabled',
      name: i18n('Disabled'),
      labelStyle: 'danger',
      borderStyle: 'danger'
    },
    waiting_for_approval: {
      id: 'waiting_for_approval',
      name: i18n('Pending'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    }
  };

  const sources = [
    { id: 'booking', title: i18n('risr/apply') },
    { id: 'kaizen', title: i18n('risr/advance') },
    { id: 'self_register', title: i18n('Self register') },
    { id: 'auto_register', title: i18n('SSO auto register') },
    { id: 'import', title: i18n('Bulk import') },
    { id: 'api', title: i18n('API') },
    { id: 'quickfill', title: i18n('Quick fill registration') },
    { id: 'not_classified', title: i18n('Not classified') }
  ];

  angular.module('component.users')
      .constant('REQUEST_RESET_PASSWORD_URL', requestResetPasswordURL)
      .constant('USER_STATES', states)
      .constant('USER_SOURCES', sources);
})();
